import React, { useState, useEffect } from 'react'

import { Icon, Table, Typography, Button, Tooltip, Col, Row } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import ParticipantIcon from '../../assets/images/agricultor.svg'
import ChecklistIcon from '../../assets/images/checklist.svg'
import GroupIcon from '../../assets/images/group-icon.svg'
import PlantacaoIcon from '../../assets/images/plantacao.svg'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { getMessage } from '../../util/IntlMessages'
import sortText from '../../util/sortText'
import { api, request } from '../../util/handlerRequestUtil'

const ListActionsPlanList = ({ history, formatedCategories, params }) => {
  const [currentCategoryName, setCurrentCategoryName] = useState('')
  const [formatedDataCategoryActions, setFormatedDataCategoryActions] = useState([])

  useEffect(() => {
    setFormatedDataCategoryActions([])
    setCurrentCategoryName('')
  }, [params])

  const renderEmptyCategoryList = () => {
    return (
      <div style={{ textAlign: '-webkit-center', margin: '10%' }}>
        <div>
          <img src={GroupIcon} alt="" />
          <Typography className="default-header-title" style={{ color: '#334863', padding: '10px 0px 10px' }} level={3}>
            {getMessage('emptyCategoryList')}
          </Typography>
        </div>
      </div>
    )
  }

  async function handleCategory(category) {
    await request(
      api.listEibCategoriaAcoesByCategory(category.id, {
        name: params.categorias,
        idRegion: params.regions,
        idDistrict: params.districts,
        idSafra: params.safra,
        active: false
      })
    )
      .then((actionsByCategory) => {
        setCurrentCategoryName(category.name)
        setFormatedDataCategoryActions(actionsByCategory)
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const renderCategoryList = () => {
    return formatedCategories.map((category) => (
      <>
        <div className="group-row" key={category.id}>
          <Typography
            className="default-header-title"
            style={{ color: '#334863', padding: '10px 30px 10px 0' }}
            level={1}
          >
            <div style={{ textAlign: 'left' }}>
              <Icon
                type={currentCategoryName === category.name ? 'up' : 'down'}
                style={{ marginRight: 10, fontSize: 15 }}
                onClick={() => {
                  if (currentCategoryName === category.name) {
                    setFormatedDataCategoryActions([])
                    setCurrentCategoryName('')
                  } else {
                    handleCategory(category)
                  }
                }}
              />
              <strong style={{ marginRight: '8px' }}>{category.name}</strong>
              <Tooltip style={{ fontSize: 15 }} placement="topLeft" title={category.proposito}>
                <InfoCircleOutlined />
              </Tooltip>
            </div>
          </Typography>

          <Row>
            <Col style={{ textAlign: 'left', width: 90 }}>{renderParticipante(category.participants)}</Col>

            <Col style={{ textAlign: 'left', width: 120 }}>{renderCobertura(category.totalArea)}</Col>

            <Col style={{ textAlign: 'left', width: 90 }}>
              <img src={ChecklistIcon} alt="" width="20" />
              {category.executed} %
            </Col>
          </Row>
        </div>

        {currentCategoryName === category.name && (
          <Table
            columns={getCategoryActionColumns()}
            dataSource={formatedDataCategoryActions}
            pagination={false}
            rowClassName={(row) => {
              if (params.categorias && params.categorias.length) {
                const regex = new RegExp(`.*${params.categorias}.*`, 'i')
                if (row.name.match(regex)) {
                  return 'row-match'
                }
              }
            }}
          />
        )}
      </>
    ))
  }

  const renderClassificationAction = (classification) => {
    return (
      <label style={{ marginRight: 10, color: '#000000' }}>
        <Icon type="star" style={{ fontSize: 20, width: 110 }} /> {+classification}
      </label>
    )
  }

  const renderParticipante = (participantes) => {
    return (
      <div style={{ textAlign: 'left', width: 110 }}>
        <img src={ParticipantIcon} alt="" width="20" /> {participantes}
      </div>
    )
  }

  const renderCobertura = (cobertura) => {
    return (
      <div style={{ textAlign: 'left', width: 110 }}>
        <img src={PlantacaoIcon} alt="" width="20" /> {parseFloat(cobertura || 0).toLocaleString('pt-BR')} ha
      </div>
    )
  }

  const formatActionsButton = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/actionsPlan/${id}?region=${params.regions}&district=${params.districts}&safra=${params.safra}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" style={{ marginLeft: -10 }} />
    </Button>
  )

  function getCategoryActionColumns() {
    const columns = [
      {
        title: getMessage('categoryActionName'),
        dataIndex: 'name',
        sorter: (a, b) => sortText(a, b, 'name'),
        width: '30%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('categoryActionClassificationBayer'),
        dataIndex: 'classificacao',
        sorter: (a, b) => sortText(a, b, 'classificacao'),
        width: '20%',
        render: (item, line) => <TableLineDisable item={renderClassificationAction(item)} line={line} />
      },
      {
        title: getMessage('participants'),
        dataIndex: 'count',
        sorter: (a, b) => sortText(a, b, 'count'),
        width: '13%',
        render: (item, line) => <TableLineDisable item={renderParticipante(item)} line={line} />
      },
      {
        title: getMessage('cobert'),
        dataIndex: 'sum',
        sorter: (a, b) => sortText(a, b, 'sum'),
        width: '13%',
        render: (item, line) => <TableLineDisable item={renderCobertura(item)} line={line} />
      },
      {
        title: getMessage('executionProgress'),
        dataIndex: 'execucao',
        sorter: (a, b) => sortText(a, b, 'execucao'),
        width: '13%',
        render: (item, line) => <TableLineDisable item={item + ' %'} line={line} />
      },
      {
        title: getMessage('actionPlain'),
        dataIndex: 'id',
        width: '13%',
        render: (item, line) => <TableLineDisable item={formatActionsButton(item)} line={line} />
      }
    ]

    return columns
  }

  return (
    <div style={{ padding: '2%' }}>
      {formatedCategories.length > 0 ? renderCategoryList() : renderEmptyCategoryList()}
    </div>
  )
}

export default ListActionsPlanList
